<div class="flex flex-col gap-3" data-testid="group-corpus-form">
  <div class="flex flex-col gap-1">
    <label class="input-label" for="group-corpus-search">Search the group corpus</label>
    <input
      id="group-corpus-search"
      type="search"
      class="input-field"
      placeholder="Title, author…"
      [value]="query()"
      (input)="onQueryChange($any($event.target).value)"
      data-testid="group-corpus-search-input"
    />
  </div>

  @if (loading()) {
    <p class="text-sm text-gray-500" data-testid="group-corpus-loading">Searching…</p>
  }

  @if (loadError(); as msg) {
    <p class="text-sm text-red-700" data-testid="group-corpus-load-error">{{ msg }}</p>
  }

  @if (results(); as page) {
    @if (page.items.length === 0) {
      <p class="rounded bg-slate-50 p-3 text-sm text-gray-600" data-testid="group-corpus-empty">
        No matching papers in the group corpus.
      </p>
    } @else {
      <ul
        class="max-h-72 divide-y divide-slate-100 overflow-y-auto rounded-md border border-slate-200"
        data-testid="group-corpus-results"
      >
        @for (paper of page.items; track paper.id) {
          <li class="p-2" [attr.data-paper-id]="paper.id">
            <label
              class="flex cursor-pointer items-start gap-2 text-sm"
              [class.opacity-60]="paper.alreadyInProject"
              [class.cursor-not-allowed]="paper.alreadyInProject"
            >
              <input
                type="checkbox"
                class="mt-1"
                [checked]="isSelected(paper.id)"
                [disabled]="paper.alreadyInProject"
                (change)="toggle(paper)"
                data-testid="group-corpus-checkbox"
              />
              <span class="min-w-0 flex-1">
                <span class="block truncate font-medium text-gray-900" [attr.title]="paper.title">
                  {{ paper.title }}
                </span>
                <span class="block text-xs text-gray-500">
                  {{ paper.authors.join(', ') }}{{ paper.year ? ' · ' + paper.year : '' }}
                </span>
                @if (paper.alreadyInProject) {
                  <span class="text-xs italic text-amber-700" data-testid="group-corpus-already">
                    already in project
                  </span>
                }
              </span>
            </label>
          </li>
        }
      </ul>

      @if (totalPages() > 1) {
        <div
          class="flex items-center justify-between text-sm text-gray-600"
          data-testid="group-corpus-pagination"
        >
          <button
            type="button"
            (click)="goToPage(currentPageIndex() - 1)"
            [disabled]="!canPrev()"
            class="btn-small-secondary disabled:cursor-not-allowed disabled:opacity-40"
            data-testid="group-corpus-prev"
          >
            « Prev
          </button>
          <span> Page {{ currentPageIndex() + 1 }} of {{ totalPages() }} </span>
          <button
            type="button"
            (click)="goToPage(currentPageIndex() + 1)"
            [disabled]="!canNext()"
            class="btn-small-secondary disabled:cursor-not-allowed disabled:opacity-40"
            data-testid="group-corpus-next"
          >
            Next »
          </button>
        </div>
      }
    }
  }

  @if (submitError(); as msg) {
    <p class="text-sm text-red-700" data-testid="group-corpus-submit-error">{{ msg }}</p>
  }

  <div
    class="sticky bottom-0 flex flex-col-reverse gap-2 border-t border-slate-200 bg-white pt-3 sm:flex-row sm:items-center sm:justify-between"
    data-testid="group-corpus-footer"
  >
    <span class="text-sm text-gray-600" data-testid="group-corpus-selected-count">
      {{ selectedIds().length }} selected
    </span>
    <button
      type="button"
      class="btn-primary w-full sm:w-auto"
      [disabled]="selectedIds().length === 0 || submitting()"
      (click)="submit()"
      data-testid="group-corpus-submit"
    >
      {{ submitting() ? 'Adding…' : 'Add to project' }}
    </button>
  </div>
</div>
